import { ChangeDetectionStrategy, Component, Input, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { IDropDownMenuItem, DropDown } from 'flux-core/src/ui';
import { Subject } from 'rxjs';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CollaboratorType } from 'flux-diagram/models';

@Component({
    template: `
                <drop-down #dropdown
                    [theme]="theme"
                    [menuItems]="collaboratorTypes"
                    [showSelected]="false"
                    [disabled]="disabled"
                    [tooltipText]="tooltipText">
                </drop-down>`,
    selector: 'alter-collab-dropdown',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlterCollabDropDown implements AfterViewInit, OnDestroy  {

    /**
     * A class that gets added to specify which theme the dropdown belongs to.
     * Ex: theme = “dark” will add the clas “dark” and apply styles which belong to the dark theme of the application.
     */
    @Input() public theme: string;

    /**
     * This holds the currently selected role
     */
    @Input() selectedValue: CollaboratorType | 'REMOVE';

    /**
     * Disable dropdown menu.
     */
    @Input()
    public disabled: boolean = false;

    /**
     * String path to the text tranlsation. If this string is given then it will show the tooltip,
     * otherwise it will not show the tooltip.
     */
    @Input()
    public tooltipText: string;

    /**
     * Excludes given list of CollaboratorTypes from Default list of CollaboratorTypes
     */
    @Input()
    public excludeCollabTypes: CollaboratorType[];

    /**
     * An observable which emits a value that got selected in the
     * menu list.
     */
    public select: Subject<any>;

   /**
    * Access the DropDown component
    */
    @ViewChild( DropDown )
    protected collabType: DropDown;

    /**
     * The list of subscriptions held by this class
     */
    protected subscriptions: Subscription[];

    constructor( protected translate: TranslateService ) {
        this.select = new Subject();
    }

    /**
     * Returns the available collaboartor roles to show in the
     * dropdown.
     */
    public get collaboratorTypes(): IDropDownMenuItem [] {
        const dropDownData = [
            {
                label: this.translate.instant( 'LABELS.CAN_MODERATE' ),
                value: CollaboratorType.MODERATOR,
                select: this.selectedValue === CollaboratorType.MODERATOR,
            },
            {
                label: this.translate.instant( 'LABELS.CAN_EDIT' ),
                value: CollaboratorType.EDITOR,
                select: this.selectedValue === CollaboratorType.EDITOR,
            },
            {
                label: this.translate.instant( 'LABELS.CAN_VIEW' ),
                value: CollaboratorType.REVIEWER,
                select: this.selectedValue === CollaboratorType.REVIEWER,
            },
            // TODO: Emanle when can comment permission is enabled.
            // {
            //     label: this.translate.instant( 'LABELS.CAN_COMMENT' ),
            //     value: 'CAN_COMMENT',
            //     select: this.selectedValue === 'CAN_COMMENT',
            // },
            {
                label: 'SEPARATOR',
                value: 'SEPARATOR',
                select: false,
                separator: true,
            },
            // TODO: Emanle when can manage permission is enabled.
            // {
            //     label: this.translate.instant( 'LABELS.CAN_MANAGE' ),
            //     value: 'CAN_MANAGE',
            //     select: this.selectedValue === 'CAN_MANAGE',
            // },
            {
                label: this.translate.instant( 'LABELS.REMOVE' ),
                value: 'REMOVE',
                select: this.selectedValue === 'REMOVE',
            },
        ];
        if ( this.excludeCollabTypes && this.excludeCollabTypes.length > 0 ) {
            return dropDownData.filter( item => !this.excludeCollabTypes.includes( item.value as any ));
        }
        return dropDownData;
    }

    /**
     * returns the currently selected item
     */
    public get selectedItem(): IDropDownMenuItem {
        return this.collabType.selectedItem;
    }

    public ngAfterViewInit() {
        this.subscriptions = [];
        const selectSub = this.collabType.select.subscribe( item => this.select.next( item ));
        this.subscriptions.push( selectSub );
    }

    /**
     * Destroys and clears all the resources used by the
     * colab privacy item.
     */
    public ngOnDestroy() {
        while ( this.subscriptions.length > 0 ) {
            this.subscriptions.pop().unsubscribe();
        }
    }

}
